export const DAYS = [["Fri", 0], ["Sat", 1], ["Sun", 2], ["Mon", 3], ["Tue", 4], ["Wed", 5], ["Thu", 6]];
export const WEEKS = [1, 2, 3, 4];
// Times may be returned without zero-padded hours (e.g. "9:00:00",
// "8:45:00"). Normalise robustly to "HH:MM" for display and "HH:MM:00" for save
// so single-digit-hour slots don't get mangled into invalid times.
export const t5 = (v) => {
  if (!v) return "";
  const [h = "", m = ""] = String(v).split(":");
  if (m === "") return String(v).slice(0, 5);
  return `${h.padStart(2, "0")}:${m.slice(0, 2).padStart(2, "0")}`;
};
export const tsec = (v) => {
  if (!v) return v;
  const [h = "0", m = "00"] = String(v).split(":");
  return `${h.padStart(2, "0")}:${m.slice(0, 2).padStart(2, "0")}:00`;
};
